<template>

  <t-page>

    <t-dialog-ordained @hidden="getPage"
                       primary-key-column="occurrenceStatusId"
                       foreign-key-column="onlaineId"
                       v-if="modalOrdained"
                       :path="currentPage.path"
                        />

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>

        <t-button v-if="userAuth.validation.validationCreate || userAuth.validation.validationUpdate" :text="'Alterar Ordem'"
                  @click="openDialogOrdained()" />

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <t-msg info>Por padrão o primeiro status comum será inserido nas aberturas de apontamentos via inspeções</t-msg>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               primary-key-column="occurrenceStatusNumber" link-primary-column="name">


        <template #item(typeOperation)="{item}">

          <div class="mb-2 mr-2 badge badge-focus" v-if="item.typeOperation === 1">Comum</div>
          <div class="mb-2 mr-2 badge badge-success" v-else-if="item.typeOperation === 2">Finalização com sucesso
          </div>
          <div class="mb-2 mr-2 badge badge-danger" v-else-if="item.typeOperation === 3">Finalização com erro (reprovado)</div>

        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogOrdained from "@/components/template/dialog/t-dialog-ordained";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogOrdained},
  name: 'TypeOccurrenceStatus',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "name", label: "Status Apontamento"},
        {key: "color", label: "Cor do Fundo", formatter: "color"},
        {key: "colorText", label: "Cor do Texto", formatter: "color"},
        {key: "typeOperation", label: "Tipo Operação"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'checklist-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
